import { getUserLocale } from './i18n.service';
const popularLanguages = ['en', 'es', 'pt', 'ru', 'fr', 'ja', 'zh', 'de', 'id', 'ar'];
export function getRecommendedDictionaries() {
    const locale = getUserLocale();
    return {
        recentlyUsed: getRecentlyUsedDictionaries(),
        recommended: popularLanguages.map(langCode => ({ l1: locale, l2: langCode }))
    };
}
const RECENTLY_USED_DICTIONARIES_COOKIE_NAME = "ld";
function getRecentlyUsedDictionaries() {
    if (!document.cookie) {
        return [];
    }
    const cookies = document.cookie.split(";").map(cookieDef => {
        const nameValue = cookieDef.split("=");
        if (nameValue.length != 2) {
            return null;
        }
        return {
            name: nameValue[0].trim(),
            value: nameValue[1].trim()
        };
    }).filter(cookie => cookie !== null);
    if (cookies.length === 0) {
        return [];
    }
    const recentlyUsedDictionariesCookie = cookies.find(({ name }) => name === RECENTLY_USED_DICTIONARIES_COOKIE_NAME);
    if (!recentlyUsedDictionariesCookie) {
        return [];
    }
    try {
        const dictionaries = JSON.parse(unescape(recentlyUsedDictionariesCookie.value));
        return dictionaries.d.map(dict => {
            const l1AndL2 = dict.split(":");
            if (l1AndL2.length !== 2) {
                return null;
            }
            return {
                l1: l1AndL2[0].trim(),
                l2: l1AndL2[1].trim()
            };
        });
    }
    catch (e) {
        // ignore
        console.error("Can't parse recently used dictionaries", e);
    }
    return [];
}
